import { render, staticRenderFns } from "./BillItemNote.vue?vue&type=template&id=b979fc62"
import script from "./BillItemNote.vue?vue&type=script&lang=js"
export * from "./BillItemNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports